import { render } from "./AlipayRedirectView.vue?vue&type=template&id=68c36f07&scoped=true"
import script from "./AlipayRedirectView.vue?vue&type=script&lang=js"
export * from "./AlipayRedirectView.vue?vue&type=script&lang=js"

import "./AlipayRedirectView.vue?vue&type=style&index=0&id=68c36f07&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c36f07"]])

export default __exports__